<template>
  <div class="bg-dashboard screen-list">
    <section id="panel-visiting">
      <!-- กำลังเข้าเยี่ยม -->
      <div v-if="visitCustomer">
        <div class="d-flex justify-space-between px-3 panel--visiting mb-6">
          <div class="d-flex align-center">
            <div class="btn--visiting mx-3">
              <span class="font-weight-bold">กำลังเข้าเยี่ยม</span>
            </div>
            <span class="font-w-500" style="color: #ffffff !important">
              <u>{{ visitCustomer.customer_name }}</u>
            </span>
          </div>
          <div class="d-flex align-center" @click="fnCheckOut()">
            <div class="btn--checkout">
              <img src="img/icons_v2/akar-icons_check-out.png" />
              <span class="text-white px-2">CHECK OUT</span>
            </div>
          </div>
        </div>

        <DialogConfirmInOut
          :dialog="dialog_confirm_inout"
          :item="visitCustomer"
          :status="status_check_inout"
          @close="dialog_confirm_inout = false"
          @save="fnSaveCheck"
        />
      </div>

      <div v-if="!visitCustomer">
        <!-- เข้าเยี่ยมแล้ว -->
        <div v-if="dataVisitDetail.status == '5'">
          <div class="d-flex justify-space-between px-3 panel--visiting mb-6">
            <div class="px-3 py-10 d-flex">
              <span class="font-weight-bold" style="color: #ffffff !important"
                >สถานะ :</span
              >
              <div class="mx-6">
                <v-icon color="#93CE55">mdi-check</v-icon>
                <span class="mx-4 font-weight-bold" style="color: #93ce55"
                  >เข้าเยี่ยมแล้ว</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- ยังไม่ได้เข้าเยี่ยม -->
        <div
          v-else
          class="d-flex justify-space-between px-3 panel--visiting mb-6"
        >
          <div class="d-flex align-center">
            <div class="mx-2">
              <span class="text-white font-weight-bold">สถานะ :</span>
            </div>
            <div class="btn--not-visiting mx-3">
              <span class="font-weight-bold">ยังไม่ได้เข้าเยี่ยม</span>
            </div>
          </div>
          <div class="d-flex align-center" @click="fnCheckIn()">
            <div class="btn--checkin">
              <img src="img/icons_v2/akar-icons_check-in.png" />
              <span class="text-white px-2">CHECK IN</span>
            </div>
          </div>
        </div>

        <DialogConfirmInOut
          :dialog="dialog_confirm_inout"
          :item="visitCustomerActive"
          :status="status_check_inout"
          @close="dialog_confirm_inout = false"
          @save="fnSaveCheck"
        />
      </div>
    </section>

    <div class="container-visit header" style="margin-top: 0px">
      <div class="card-top">
        <base-visit-profile :data="resultVisit"></base-visit-profile>
        <div v-if="resultVisit.planBy != 0">
          <btn-visit-plan
            :data="{ plan: resultVisit.planBy, name: resultVisit.planbyName }"
          ></btn-visit-plan>
        </div>
      </div>

      <VisitDatePlan
        v-if="visitShopDetailMode !== 'readonly'"
        :data="data_dateplan"
        :action="'update'"
        :planby="planByAction"
        @setDueDate="postSetDueDate"
        @changeDueDate="postChangeDueDate"
      />
    </div>

    <div style="border-top: 1px solid #ececec">
      <v-tabs v-model="tab" color="#A9182A" height="50" grow>
        <v-tab>รายละเอียดร้านค้า</v-tab>
        <v-tab v-if="visitShopDetailMode !== 'readonly'">TO DO LIST</v-tab>
      </v-tabs>

      <div v-if="tab === 0">
        <VisitShopDetail :bpDetail="dataVisitDetail.bp_detail" />
      </div>

      <div v-if="tab === 1" class="container-visit todolist">
        <VisitTodoTable :bpDetail="dataVisitDetail.bp_detail" />

        <!-- <VisitTodoList
          v-if="statusAction"
          :todo="resultVisit.todoList"
          @remove="removeTodoList"
          @add="addTodoList"
          @edit="editTodoList"
        /> -->

        <!-- <VisitTodoListViews v-else :todo="resultVisit.todoList" /> -->

        <VisitNote
          v-if="statusAction"
          :data="resultVisit.note"
          class="mt-4"
          @add="addNote"
        />
      </div>
    </div>

    <DialogConfirm
      :dialog="dialog_cf"
      :id="visitID"
      @close="toggleDialogConfirm(false)"
      @submit="submitConfirm"
    />

    <div
      class="container-visit"
      :class="[isChangeDueDate || isPlanOwner ? 'submit' : 'submit-found']"
    >
      <button
        v-show="(actionRemove && isChangeDueDate) || isPlanOwner"
        type="button"
        class="btn-visit-remove"
        @click="toggleDialogConfirm(true)"
      >
        ลบแผนเข้าเยี่ยม
      </button>

      <button
        type="button"
        class="btn-visit-pricestock text-center"
        @click="linkToPriceStock(resultVisit.customerID)"
      >
        <img src="img/icons_v2/icon-note-ps.png" class="mx-2" />
        Price & Stock
      </button>

      <button
        v-if="showSaveBtn"
        type="button"
        class="btn-visit-submit"
        @click="submitVisit"
      >
        บันทึกการเข้าเยี่ยม
      </button>
    </div>
  </div>
</template>

<script>
import VisitDatePlan from '@/components/v2/calendar/VisitDatePlan.vue'
import VisitShopDetail from '@/components/v2/calendar/visitShopDetail/VisitShopDetail.vue'
// import VisitTodoList from '@/components/v2/calendar/VisitTodoList.vue'
import VisitTodoTable from '@/components/v2/calendar/todoLIst/VisitTodoTable.vue'
// import VisitTodoListViews from '@/components/v2/calendar/VisitTodoListViews.vue'
import VisitNote from '@/components/v2/calendar/VisitNote.vue'
import BaseVisitProfile from '@/components/v2/ui/BaseVisitProfile.vue'
import DialogConfirm from '@/components/v2/dialog/DialogConfirm.vue'
import DialogConfirmInOut from '@/components/v2/checkinout/DialogConfirmInOut.vue'
import { mapState } from 'vuex'

export default {
  components: {
    VisitDatePlan,
    VisitShopDetail,
    // VisitTodoList,
    VisitTodoTable,
    // VisitTodoListViews,
    VisitNote,
    BaseVisitProfile,
    DialogConfirm,
    DialogConfirmInOut,
  },

  data() {
    return {
      customerID: this.$route.params.customerID,
      visitID: this.$route.params.visitID,
      dataVisitDetail: {
        status: 0,
        bp_detail: {},
      },
      resultVisit: [],

      form: {
        visit_id: this.$route.params.visitID,
        note: null,
        todo_list: [],
      },

      data_dateplan: {
        visitID: '',
        dateVisit: '',
        dateStatus: '',
        dateVisitEN: '',
        status: '',
        checkInTime: '',
        checkOutTime: '',
        checkTime: '',
      },

      dialog_cf: false,
      visitCustomer: '',
      visitCustomerActive: '',

      dialog_confirm_inout: false,
      status_check_inout: '',

      tab: 0,

      isChangeDueDate: false,
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      accessToken: (state) => state.auth.accessToken,
      location: (state) => state.checkinout.location,
    }),

    isPlanOwner() {
      return (
        this.$store.state.auth.user.id === this.dataVisitDetail.planby_user_id
      )
    },

    visitShopDetailMode() {
      return this.$route.query.mode
    },

    visitShopDetailCondition() {
      return this.$store.state.visitShopDetail.condition
    },

    visitShopDetailSort() {
      return this.$store.state.visitShopDetail.sort
    },

    planByAction() {
      const statusPlan = this.resultVisit.planBy
      var result = null
      if (statusPlan == 0 || statusPlan == 1) {
        result = false
      } else {
        result = true
      }
      return result
    },

    statusAction() {
      // true = แก้ไขได้ // false = แก้ไขไม่ได้
      // const status = this.resultVisit.status
      // const date = this.resultVisit.dateVisit
      // var result = null
      // if (status != 0 || status != 4) {
      //   if (date == '') {
      //     result = false
      //   } else {
      //     result = true
      //   }
      // } else {
      //   result = false
      // }
      return true
    },

    actionRemove() {
      if (this.visitID != 0 && this.resultVisit.planBy != 1) {
        return true
      } else {
        return false
      }
    },

    showSaveBtn() {
      if (
        this.visitShopDetailMode === 'readonly' ||
        this.data_dateplan.dateVisit === ''
      ) {
        return false
      }
      return true
    },
  },

  watch: {
    visitShopDetailCondition() {
      this.getDashboardBTAnalyticBT()
    },

    visitShopDetailSort() {
      this.getDashboardBTAnalyticBT()
    },
  },

  methods: {
    async getDashboardBTAnalyticBT() {
      try {
        this.$store.commit('visitShopDetail/detailListLoadUpdate', true)
        const res = await this.$axios.post(
          `${this.$baseAPI}/visit/getdashboardBTAnalyticBT`,
          {
            scg_bp_number: this.dataVisitDetail.ScgBPNumber,
            condition: this.visitShopDetailCondition, //1,2,3 ตามลำดับ
            sort: this.visitShopDetailSort, // DESC,ASC
          },
          {
            headers: this.setheaders,
          },
        )
        this.$store.commit('visitShopDetail/detailListUpdate', res.data.detail)
      } catch (error) {
        console.error(error)
        this.$store.commit('visitShopDetail/detailListUpdate', [])
      } finally {
        this.$store.commit('visitShopDetail/detailListLoadUpdate', false)
      }
    },
    async getVisitDetail() {
      const data = {
        method: 'POST',
        headers: this.setheaders,
        body: JSON.stringify({
          visit_id: parseInt(this.visitID),
          customer_id: parseInt(this.customerID),
          lat_lng: this.location,
        }),
      }

      fetch(`${this.$baseAPI}/visit/detail`, data)
        .then((response) => {
          return response.json()
        })
        .then((res) => {
          this.dataVisitDetail = res.detail
          this.dataFormatVisitDetail()
          this.getVisitingCustomer()
          this.getDashboardBTAnalyticBT()
        })
    },

    dataFormatVisitDetail() {
      const data = this.dataVisitDetail
      const result = this.displayVisitDetail(data) // global function #format data

      this.resultVisit = result
      this.form = {
        visit_id: result.visitID,
        note: result.note,
        todo_list: result.todoList,
      }

      this.dataDatePlan(result)
    },

    dataDatePlan(data) {
      this.data_dateplan = {
        visitID: data.visitID,
        dateVisit: data.dateVisit,
        dateStatus: data.dateStatus,
        dateVisitEN: data.dateVisitEN,
        status: data.status,
        checkInTime: data.checkInTime,
        checkOutTime: data.checkOutTime,
        checkTime: data.checkTime,
      }
    },

    addNote(value) {
      this.form.note = value
    },

    // addTodoList(value) {
    //   this.resultVisit.todoList.push({
    //     todo_id: Math.floor(Math.random() * 100000) + 1,
    //     plan_by: '2',
    //     detail: value,
    //     status: false,
    //   })
    // },

    // editTodoList(value, index) {
    //   this.resultVisit.todoList[index].detail = value
    // },

    // removeTodoList(TodoListID) {
    //   this.resultVisit.todoList = this.resultVisit.todoList.filter(
    //     (item) => item.todo_id !== TodoListID,
    //   )
    // },

    postSetDueDate(valueDate) {
      this.isChangeDueDate = true

      const data = {
        method: 'POST',
        headers: this.setheaders,
        body: JSON.stringify({
          customer_id: this.customerID,
          date: valueDate,
        }),
      }

      fetch(`${this.$baseAPI}/visit/set_plan`, data)
        .then((response) => {
          return response.json()
        })
        .then((res) => {
          const customer_id = this.customerID
          const visit_id = res.detail.visit_id
          this.$router.push({
            path: `/visitdetail/${customer_id}/${visit_id}`,
          })
          this.visitID = visit_id
          this.form.visit_id = visit_id
          setTimeout(() => {
            const result = this.displayVisitDetail(res.detail)
            this.dataDatePlan(result)
          }, 250)
        })
    },

    postChangeDueDate(value) {
      const result = this.displayVisitDetail(value)
      this.dataDatePlan(result)
      this.isChangeDueDate = true
    },

    submitVisit() {
      this.form.todo_list = this.resultVisit.todoList // push to do list

      const data = {
        method: 'POST',
        headers: this.setheaders,
        body: JSON.stringify(this.form),
      }

      fetch(`${this.$baseAPI}/visit/update`, data)
        .then((response) => {
          return response.json()
        })
        .then((res) => {
          if (res.ret.error === 0) {
            Swal.fire({
              icon: 'success',
              html: "<span style='font-size: 2.3rem; font-weight: 500;'>บันทึกข้อมูลสำเร็จ</span>",
              showConfirmButton: false,
              timer: 1500,
            })
            this.$router.push({ path: '/calendar' })
          } else {
            Swal.fire({
              icon: 'error',
              html: "<span style='font-size: 2.3rem; font-weight: 500;'>บันทึกการเข้าเยี่ยมไม่สำเร็จ</span>",
              showConfirmButton: true,
              confirmButtonText: `ตกลง`,
              confirmButtonColor: '#A9182A',
            })
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: 'error',
            html: "<span style='font-size: 2.3rem; font-weight: 500;'>บันทึกการเข้าเยี่ยมไม่สำเร็จ</span>",
            showConfirmButton: true,
            confirmButtonText: `ตกลง`,
            confirmButtonColor: '#A9182A',
          })
          console.log(error)
        })
    },

    toggleDialogConfirm(status) {
      this.dialog_cf = status
    },

    submitConfirm(id) {
      this.dialog_cf = false

      const data = {
        method: 'POST',
        headers: this.setheaders,
        body: JSON.stringify({
          visit_id: id,
        }),
      }

      fetch(`${this.$baseAPI}/visit/inactivePlan`, data)
        .then((response) => {
          return response.json()
        })
        .then(() => {
          this.$router.push('/calendar')
        })
    },

    getVisitingCustomer() {
      this.$store
        .dispatch('checkinout/visitCustomers', { user_id: this.user.id })
        .then((res) => {
          this.visitCustomer = res.length === 0 ? null : res
        })
    },

    fnCheckOut() {
      this.dialog_confirm_inout = true
      this.status_check_inout = false // false =  check out
    },

    fnCheckIn() {
      this.dialog_confirm_inout = true
      this.status_check_inout = true // false =  check in
      this.visitCustomerActive = this.dataVisitDetail
    },

    fnSaveCheck(item) {
      this.dialog_confirm_inout = false

      const formData = {
        user_id: this.user.id,
        customer_id: item.customer_id,
        lat_lng: this.location,
      }

      const activeInout = this.status_check_inout

      this.$store
        .dispatch('checkinout/getCheckInOut', { formData })
        .then((res) => {
          if (res.status == 200) {
            if (activeInout == true) {
              Swal.fire({
                icon: 'success',
                title: `${res.message}`,
                showConfirmButton: false,
                timer: 1500,
              })
            } else {
              Swal.fire({
                icon: 'success',
                title: `${res.message}`,
                showConfirmButton: false,
                timer: 1500,
              })
            }

            this.getVisitDetail()
          } else {
            if (activeInout == true) {
              Swal.fire({
                icon: 'warning',
                title: `ไม่สามารถเช็คอินได้`,
                html: `${res.message}`,
                showConfirmButton: false,
                timer: 3500,
              })
            } else {
              Swal.fire({
                icon: 'warning',
                title: `ไม่สามารถเช็คเอาท์ได้`,
                html: `${res.message}`,
                showConfirmButton: false,
                timer: 3500,
              })
            }
          }
        })
    },

    linkToPriceStock(customerId) {
      this.$router.push(`/stock?direct_visit=true&customer_id=${customerId}`)
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.dispatch('setTitle', 'เข้าเยี่ยม')
      this.$store.dispatch('checkinout/getLocation')
    })

    // set background
    const wrap = document.querySelectorAll('.v-application--wrap')
    wrap[0].style.backgroundColor = '#eef3fa'

    this.getVisitDetail()
  },
}
</script>

<style lang="scss" src="@/assets/scss/visit/visit-detail.scss"></style>
